import { UDEMY_RELATIVE_LOGO_URLS } from '@udemy/react-brand-components';
const assetPath = process.env.ASSET_PREFIX || 'https://www.udemy.com';
export const udemyLogoUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.udemyLogoUrl}`;
export const udemyLogoInvertedUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.udemyLogoInvertedUrl}`;
export const ubLogoUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.ubLogoUrl}`;
export const ubLogoInvertedUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.ubLogoInvertedUrl}`;
export const ugLogoUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.ugLogoUrl}`;
export const ugLogoInvertedUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.ugLogoInvertedUrl}`;
export const udemyProLogoUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.udemyProLogoUrl}`;
export const udemyBenesseLogoUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.udemyBenesseLogoUrl}`;
export const udemyBenesseLogoInvertedUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.udemyBenesseLogoInvertedUrl}`;
//# sourceMappingURL=udemy-logo-urls.js.map